export default __webpack_public_path__ + "media/images/bmc-logo.png";